import type {
  CmmInputUniqueValueItem,
  CmmInputUniqueValuesDoc,
} from "../../validationFunnel/pages/conditionList/cmmInputUniqueValuesTypes";
import {
  normalizeCmmInputUniqueValuesDoc,
  normalizeTopValues,
} from "../../validationFunnel/pages/conditionList/cmmInputUniqueValuesTypes";

/** Condition-list column whose top values populate batch dropdowns. */
export const FILENAME_BATCH_COLUMN = "filename";

/**
 * Converts condition-list top values into plain string options.
 *
 * @param topValues - Raw top values from the condition list column.
 * @return Distinct, non-empty string values.
 */
export const extractTopValueStrings = (
  topValues: (CmmInputUniqueValueItem | string | number | boolean)[],
): string[] =>
  normalizeTopValues(topValues)
    .map((entry) => {
      const isItemShape =
        entry != null && typeof entry === "object" && "value" in entry;
      const value = isItemShape
        ? (entry as CmmInputUniqueValueItem).value
        : entry;
      return String(value ?? "").trim();
    })
    .filter(Boolean);

/**
 * Reads batch dropdown options from the `filename` row in the condition list doc.
 *
 * @param doc - Normalized CMM input unique values document.
 * @return Distinct filename top values for batch selection.
 */
export const getFilenameBatchOptionsFromDoc = (
  doc: CmmInputUniqueValuesDoc | null,
): string[] => {
  const normalized = normalizeCmmInputUniqueValuesDoc(doc);
  const filenameColumn = normalized?.columns?.find(
    (column) => column.column_name === FILENAME_BATCH_COLUMN,
  );
  if (!filenameColumn) return [];

  return Array.from(new Set(extractTopValueStrings(filenameColumn.top_values)));
};
